/**
 * TAP — qué tema viste esta pantalla, resuelto POR HOSTNAME.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * POR QUÉ POR HOSTNAME Y NO POR UNA CONSTANTE DEL BUILD
 * ═══════════════════════════════════════════════════════════════════════════
 * Hoy hay UN venue y el build ya es por venue, así que una constante
 * funcionaría. El hostname se usa igual por dos razones medidas, no por
 * anticipar:
 *
 *   1. El mismo bundle ya se sirve en DOS nombres. `venues/panem.env` declara
 *      `ALIAS_HOST` además del nombre bueno, y Caddy sirve el mismo sitio en
 *      los dos. Una constante del build no distingue, y el día que el alias
 *      sea de otra cosa nadie se entera.
 *   2. Es el mecanismo que NO estorba después. Cuando llegue el segundo venue,
 *      el cambio es un renglón en el mapa, no una recompilación por nombre.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Y POR QUÉ NO ADIVINA
 * ═══════════════════════════════════════════════════════════════════════════
 * Un hostname que no está en el mapa **no** se resuelve por parecido ni por
 * subdominio. Devuelve el respaldo, que es el tema del venue para el que se
 * construyó este bundle. Adivinar «panem.loquesea.mx → panem» es cómo un venue
 * acaba vestido de otro en una pantalla que nadie revisó.
 */

/** La clase que envuelve la app. Es el contenedor del sistema de diseño. */
export const CONTENEDOR = "panem-ui";

/**
 * Lee el mapa `hostname → tema` que inyecta el despliegue.
 *
 * Viene como JSON en `VITE_TEMAS` porque un objeto de verdad no sobrevive a
 * una variable de entorno. Si viene vacío, mal formado, o no es un objeto de
 * puras cadenas, se devuelve un mapa VACÍO y la resolución cae al respaldo: un
 * tema mal escrito en el despliegue no puede dejar la pantalla sin vestir.
 */
export function mapaDeTemas(crudo: string | undefined): Record<string, string> {
  if (!crudo) return {};
  let dato: unknown;
  try {
    dato = JSON.parse(crudo);
  } catch {
    return {};
  }
  if (typeof dato !== "object" || dato === null || Array.isArray(dato)) return {};
  const limpio: Record<string, string> = {};
  for (const [host, tema] of Object.entries(dato as Record<string, unknown>)) {
    if (typeof tema === "string" && tema !== "") limpio[host.toLowerCase()] = tema;
  }
  return limpio;
}

/**
 * El tema de este hostname, o el respaldo.
 *
 * El hostname se normaliza a minúsculas —los nombres de dominio no distinguen
 * caja y un `Panem.PeopleIntelligence.mx` tecleado a mano es una visita
 * legítima— y se le quita el puerto, que `location.hostname` no trae pero un
 * `location.host` sí, y los dos se confunden a cada rato.
 */
export function temaDeHostname(
  hostname: string,
  mapa: Record<string, string>,
  respaldo: string,
): string {
  const limpio = hostname.toLowerCase().split(":")[0] ?? "";
  return mapa[limpio] ?? respaldo;
}
